import React from 'react';

function Modal({ onClose, children }) {
  return (
    <div className="edit-modal-overlay" onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div className="edit-modal">
        {children}
      </div>
    </div>
  );
}

export default Modal;
